import type { TranslationMessages } from '../../types';

export const ranking: TranslationMessages = {
  title: 'Bảng xếp hạng',
  leaderboard: 'Bảng xếp hạng',
  personal_ranking: 'Xếp hạng cá nhân',
  your_rank: 'Hạng của bạn',
  your_score: 'Điểm của bạn',
  percentile: 'Phần trăm',
  ranking_criteria: 'Tiêu chí xếp hạng',
  attitude: 'Thái độ',
  customer_feedback: 'Phản hồi khách hàng',
  working_quality: 'Chất lượng làm việc',
  attendance: 'Điểm danh',
  overall: 'Tổng thể',
  top_performers: 'Người biểu diễn hàng đầu',
  rank: 'Hạng',
  score: 'Điểm',
  change_criteria: 'Thay đổi tiêu chí',
  apply_criteria: 'Áp dụng tiêu chí',
  monthly_reset: 'Đặt lại hàng tháng',
  quarterly_reset: 'Đặt lại hàng quý',
  no_rankings: 'Không có xếp hạng nào',
};
